<div class="sidebar-header">{{headerContent}}</div>
<form class="standard-form create-keymeasure-form"
      (ngSubmit)="onSubmit()"
      [formGroup]="keyMeasureForm"
      *ngIf="isActive">
  <!-- Instructions -->
  <div class="sans-margin">
    <ng-container *ngIf="isEdit">
      <!-- Edit Mode -->
      <p class="flyout-instruction opac-75">Please add a unique statement for each Key Measure.</p>
      <p class="flyout-instruction dark"><strong>Key Measure to be applied to the following Critical Initiative:</strong></p>
      <p class="flyout-instruction opac-75 hard-break-text"><i>{{initiativeDescription}}</i></p>
      <div>
        <div class="well" *ngIf="!(formLoading | async); else formLoadingContent">
          <div class="create-row">
            <ng-container *ngTemplateOutlet="createKeyMeasureContent"></ng-container>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!isEdit">
      <!-- Create Mode -->
      <p class="flyout-instruction">Please add a unique statement for each Key Measure.</p>
      <p class="flyout-instruction"><strong>Key Measure to be applied to the following Critical Initiative:</strong></p>
      <p class="flyout-instruction hard-break-text"><i>{{initiativeDescription}}</i></p>
      <div *ngIf="hasKeyMeasures; else noKeyMeasures">
        <!-- New Key Measure Create -->
        <div class="well" *ngIf="!(formLoading | async); else formLoadingContent">
          <label>Please create a new Key Measure <strong>or</strong> select from an established Key Measure.</label>
          <div class="radio-container">
            <div class="select-keymeasure-content">
              <div class="radio-row">
                <p-radioButton
                  name="keyMeasureCreateMethod"
                  value="select"
                  label="Select an Established Key Measure"
                  id="keyMeasureSelectRadio"
                  formControlName="keyMeasureCreateMethod"></p-radioButton>
              </div>
              <div *ngIf="keyMeasureCreateMethod.value === 'select'"
                    class="create-row">
                <!-- Key Measure Select -->
                <div class="sans-margin">
                  <p-dropdown auto="key-measure-select"
                              class="standard-input block"
                              id="initiativeKeyMeasureSelect"
                              name="existingKeyMeasure"
                              placeholder="Select a Key Measure"
                              [autoWidth]="false"
                              [options]="keyMeasureSelectItems"
                              formControlName="existingKeyMeasure">
                  </p-dropdown>
                  <div *ngIf="existingKeyMeasure.value" class="selected-keymeasure-tag-container">
                    <p class="selected-keymeasure-tag"><strong>Tag: </strong>{{existingKeyMeasure.value.tagValue}}</p>
                  </div>
                </div>
                <!-- Add Button Row -->
                <div class="secondary-button-row" *ngIf="!isEdit">
                  <input auto="add-key-measure-modal"
                         class="btn"
                         type="button"
                         [disabled]="isAddDisabled"
                         (click)="onAddMeasureClick()"
                         value="Add"/>
                </div>
              </div>
            </div>
            <div class="create-keymeasure-content">
              <div class="radio-row">
                <p-radioButton
                  name="keyMeasureCreateMethod"
                  value="create"
                  label="Create a New Key Measure"
                  id="keyMeasureCreateRadio"
                  formControlName="keyMeasureCreateMethod"></p-radioButton>
              </div>
              <div *ngIf="keyMeasureCreateMethod.value === 'create'" class="create-row">
                <ng-container *ngTemplateOutlet="createKeyMeasureContent"></ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <!-- Added Key Measures Table -->
  <div class="input-error-wrap sans-margin" *ngIf="!isEdit">
    <!-- keymeasures-table -->
    <p-table [value]="keyMeasures" auto="key-measures-table-modal" styleClass="keymeasures-create-table rounded-zebra-table">
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="2" class="ui-table-empty-message">
            <p><strong>No Key Measures Found.</strong></p>

            <p>When you add Key Measures they will be listed here.</p>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th><strong>Key Measure(s)</strong></th>
          <th class="actions-column"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-keyMeasure>
        <tr>
          <td>
            {{keyMeasure.measure}}
          </td>
          <td class="actions-column">
            <div class="fa-icon pointer" (click)="onDeleteMeasureClick(keyMeasure)">
              <i auto="delete-key-measure-modal" class="fa fa-trash"></i>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="button-row">
    <button auto="cancel-key-measure-modal" class="btn btn-alt left-btn" type="button"
            (click)="cancel.emit()">Cancel</button>
    <button auto="save-key-measure-modal" class="btn" type="submit" [disabled]="isSubmitDisabled">Save</button>
  </div>
  <!-- Content Templates -->
  <!-- Loading Frame Content -->
  <ng-template #formLoadingContent>
    <div class="well">
      <p>Loading</p>
    </div>
  </ng-template>
  <!-- Has No Key Measures Content -->
  <ng-template #noKeyMeasures>
    <div class="well">
      <label class="standard-label" for="keyMeasure">Create a New Key Measure</label>
      <ng-container *ngTemplateOutlet="createKeyMeasureContent"></ng-container>
    </div>
  </ng-template>
  <!-- Create / Edit Key Measure Content -->
  <ng-template #createKeyMeasureContent>
    <label class="standard-label" for="keyMeasure">Key Measure</label>
    <div class="input-error-wrap sans-margin">
      <input auto="key-measure-name-field" class="standard-input block" type="text" id="keyMeasure"
             placeholder="Enter a Key Measure" name="keyMeasure" [formControl]="measure" [maxlength]="MAX_MEASURE_LENGTH"
             (blur)="validateKeyMeasureUniqueness()"
             (keyup)="setValidationTimeout()">
      <div class="remaining-msg">Remaining: {{ measureRemainingCharacters }}</div>
      <div *ngIf="measure.invalid && measure.touched" [ngStyle]="{'padding-bottom': '10px'}">
        <app-error-msg [control]="measure" [show]="measure.invalid && measure.touched"></app-error-msg>
      </div>
    </div>
    <!-- Tag Selection -->
    <label class="standard-label" for="initiativeTag">Select a Tag</label>
    <div class="sans-margin">
      <p-dropdown auto="key-measure-tag"
                  class="standard-input block"
                  id="initiativeTag"
                  name="initiative tag"
                  [autoWidth]="false"
                  [options]="tagSelectItems"
                  placeholder="Select a Tag"
                  [formControl]="tag">
      </p-dropdown>
      <app-error-msg
        [control]="tag"
        *ngIf="tag.invalid && tag.touched"
        [show]="tag.invalid && tag.touched"></app-error-msg>
    </div>
    <!-- Add Button Row -->
    <div class="secondary-button-row" *ngIf="!isEdit">
      <input auto="add-key-measure-modal"
             class="btn"
             type="button"
             [disabled]="isAddDisabled"
             [ngClass]="{'top-margin-10': !tag.invalid || !tag.touched}"
             (click)="onAddMeasureClick()" value="Add"/>
    </div>
  </ng-template>
</form>
